import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
interface CategoryCardProps {
  category: CategoriesEntity;
  detailedStyles?: boolean;
  onClick?: () => void;
}

export function CategoryCard({ category, detailedStyles = false, onClick }: CategoryCardProps) {
  return (
    <Link
      prefetch={false}
      href={ROUTES.CATEGORY({ slug: category.slug, page: 1 })}
      onClick={onClick}
      className={cn(
        'relative col-span-1 w-full overflow-hidden p-4 transition-all hover:opacity-90 lg:p-5',
        'ea-category-card',
      )}
    >
      <p
        className={cn(
          'relative z-10 text-sm font-semibold xl:text-base',
          category.icon?.custom_title === 'percent' || !category.icon?.url
            ? 'text-white'
            : 'text-black',
        )}
      >
        {category.name}
      </p>
      {detailedStyles ? (
        <>
          {category.icon?.custom_title !== 'percent' && category.icon && category?.icon.url && (
            <>
              <div
                className={cn(
                  'absolute inset-0 z-[2] h-full w-full',
                  'bg-gradient-to-r from-[#f5f5f5] to-[#f5f5f52c]',
                )}
              />
              <Image
                src={category?.icon?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(category?.icon, category?.name)}
                width={0}
                height={0}
                className="absolute inset-0 z-0 h-full w-full object-cover object-center grayscale"
                sizes="300px"
              />
            </>
          )}
          {category.icon?.custom_title === 'percent' && (
            <>
              <Image
                src={category.icon?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(category?.icon, category?.name)}
                width={0}
                height={0}
                className="absolute right-0 top-0 z-[2] h-full w-auto object-cover"
              />
              <Image
                src={'/images/sale-models.jpg'}
                alt={category.name}
                width={0}
                height={0}
                className="absolute inset-0 z-0 h-full w-full object-cover object-center"
              />
            </>
          )}
          {!category.icon?.url && (
            <Image
              src={'/images/subcategory-no-bg.jpg'}
              alt={category.name}
              width={0}
              height={0}
              className="absolute inset-0 z-0 h-full w-full object-cover object-center"
            />
          )}
        </>
      ) : (
        <></>
      )}
    </Link>
  );
}
